<template>
  <Dialog :show.sync="visible" width="500px" title="滤波">
    <template v-slot:body>
      <div class="dialog-body">
        <el-form :model="formData" ref="formRef" label-width="auto" size="small" :rules="rules">
          <el-form-item prop="filterType" label="滤波类型">
            <el-select v-model="formData.filterType">
              <el-option
                  v-for="item in types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item prop="lowFrequency" label="起始频率（Hz）" v-if="formData.filterType !== 'Lowpass'">
            <el-input-number :controls="false" :min="0" v-model="formData.lowFrequency" style="width: 100%"/>
          </el-form-item>
          <el-form-item prop="highFrequency" label="截止频率（Hz）" v-if="formData.filterType !== 'Highpass'">
            <el-input-number :controls="false" :min="0" v-model="formData.highFrequency" style="width: 100%"/>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('cancel_k') }}</el-button>
      <el-button size="small" type="primary" @click="save">{{ $t('confirm_k') }}</el-button>
    </div>
  </Dialog>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      formData: {
        filterType: 'Highpass',
        lowFrequency: '',
        highFrequency: '',
      },
      types: [
        {
          value: 'Highpass',
          label: '高通'
        },
        {
          value: 'Lowpass',
          label: '低通'
        },
        {
          value: 'Bandpass',
          label: '带通'
        },
        {
          value: 'Bandstop',
          label: '带阻'
        },
      ]
    }
  },
  computed: {
    rules() {
      return {
        filterType: {required: true, message: '请选择滤波类型', trigger: 'change'},
        lowFrequency: {required: true, message: '请输入起始频率', trigger: 'blur'},
        highFrequency: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const {filterType,lowFrequency} = this.formData
              if (!value && value !== 0) {
                callback(new Error('请输入截止频率'))
              } else if (filterType !== 'Lowpass' && lowFrequency && value <= lowFrequency) {
                callback(new Error('截止频率必须大于起始频率'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    save() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        this.$emit('success', this.formData)
        this.visible = false
      })
    }
  }
}
</script>
